import { Instagram, Twitter, Facebook, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FOOTER } from '@/constants/testIds';

const LOGO = 'https://customer-assets.emergentagent.com/job_cb412e5d-8af6-43ed-9f51-c9b9fc01bd76/artifacts/t1468n8c_SUMAYA_no%20BG_Green.png';

const columns = [
  {
    title: 'Shop',
    items: [
      { label: 'Shop All', href: '/#shop' },
      { label: 'Detox Tea', href: '/#shop' },
      { label: 'Bedtime Tea', href: '/#shop' },
      { label: "Women's Care Tea", href: '/#shop' },
    ],
  },
  {
    title: 'Learn',
    items: [
      { label: 'About Us', href: '#' },
      { label: 'FAQ', href: '#' },
      { label: 'Ingredient Dictionary', href: '/ingredients' },
      { label: 'The Ritual Journal', href: '#' },
    ],
  },
  {
    title: 'Support',
    items: [
      { label: 'Contact Us', href: '#' },
      { label: 'Returns, Refunds & Cancellations', href: '#' },
      { label: 'Shipping', href: '#' },
      { label: 'My Account', href: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[#0D3A24] text-[#FAF4E3] overflow-hidden"
    >
      <div className="blob absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#2D8B5B]" />
      <div className="blob absolute -bottom-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#1D7448]" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="bg-[#FAF4E3] inline-block p-4 rounded-2xl">
              <img src={LOGO} alt="Sumaya" className="h-12 w-auto" />
            </div>
            <p className="mt-6 font-serif text-2xl md:text-3xl leading-tight text-[#FAF4E3]/95 max-w-sm">
              Ancient herbs. <br />Modern rituals.
            </p>
            <p className="mt-4 text-sm text-[#FAF4E3]/60 max-w-sm leading-relaxed">
              Thoughtfully blended tea rituals for the modern life — small daily
              acts of care, steeped in centuries of tradition.
            </p>

            <div className="mt-8 flex items-center gap-3">
              {[Instagram, Twitter, Facebook, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social link"
                  className="w-11 h-11 rounded-full border border-[#FAF4E3]/25 flex items-center justify-center hover:bg-[#FAF4E3] hover:text-[#1D7448] transition-colors duration-300"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-10">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="text-xs uppercase tracking-[0.24em] text-[#FAF4E3]/50 mb-5">
                  {col.title}
                </h4>
                <ul className="space-y-3">
                  {col.items.map((it) =>
                    it.href.startsWith('/') && !it.href.includes('#') ? (
                      <li key={it.label}>
                        <Link
                          to={it.href}
                          className="text-[15px] text-[#FAF4E3]/90 hover:text-white transition-colors"
                        >
                          {it.label}
                        </Link>
                      </li>
                    ) : (
                      <li key={it.label}>
                        <a
                          href={it.href}
                          className="text-[15px] text-[#FAF4E3]/90 hover:text-white transition-colors"
                        >
                          {it.label}
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FAF4E3]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#FAF4E3]/50">
          <p>© {new Date().getFullYear()} Sumaya. Steeped with intention.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms & Conditions</a>
            <a href="#" className="hover:text-white">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
